/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseBlogGridFragment} from '@amblique/contentful/app/contentful/fragments/blog-grid/base-blog-grid.fragment';
import {BaseBlogFragment} from '@amblique/contentful/app/contentful/fragments/blog/base-blog.fragment';
import {BaseLinkFragment} from '@amblique/contentful/app/contentful/fragments/link/base-link.fragment';

export const BlogGridFragment = gql`
  ${BaseBlogFragment}
  ${BaseBlogGridFragment}
  ${BaseLinkFragment}

  fragment BlogGridFragment on BlogGrid {
    ...BaseBlogGridFragment

    blogSummaryCollection {
      items {
        __typename
        ... on Blog {
          ...BaseBlogFragment
        }
      }
    }
    cta {
      ...BaseLinkFragment
    }
  }
`;
